import React from "react";
import { Link } from "react-router-dom";
import { Box, Text, HStack, Card, Badge, Image, Flex, Menu, Portal } from "@chakra-ui/react";
import { Button } from "components/ui/Button";
import { MdEdit, MdMoreHoriz } from "react-icons/md";

function MainAct({ id, nombre, fecha, desc, horaInicio, horaFin, foto, published = true, isIncomplete = false, onDelete, onTogglePublish }) {
  const menuItemProps = { _highlighted: { bg: "dashboard.bg.surfaceMuted" } };

  const doDelete = () => {
    if (typeof onDelete === "function") onDelete(id);
  };
  const doTogglePublish = () => {
    if (typeof onTogglePublish === "function") onTogglePublish(id);
  };

  return (
    <Menu.Root>
      <Card.Root
        overflow="hidden"
        bg="dashboard.bg.surface"
        borderWidth="1px"
        borderColor="dashboard.border.muted"
        rounded="card"
      >
        <Flex direction={{ base: "column", md: "row" }} alignItems="stretch" minH={{ md: "280px" }}>

          {/* Image */}
          <Box
            position="relative"
            w={{ base: "100%", md: "280px" }}
            h={{ base: "200px", md: "auto" }}
            flexShrink={0}
            alignSelf={{ base: "auto", md: "stretch" }}
            overflow="hidden"
          >
            <Image
              position="absolute"
              inset="0"
              objectFit="cover"
              w="100%"
              h="100%"
              src={foto}
              alt={nombre}
              filter={published ? "none" : "grayscale(1)"}
            />
            <Box
              position="absolute"
              inset="0"
              bg="linear-gradient(to top, rgba(0,0,0,0.38), transparent 55%)"
            />
            <HStack position="absolute" top="3" left="3" right="3" justify="space-between" align="start" gap="2">
              <HStack gap="1.5" minW="0" wrap="wrap">
                {!published && (
                  <Badge
                    colorPalette="gray"
                    variant="solid"
                    rounded="full"
                    px="2.5"
                    py="1"
                    fontSize="10px"
                    fontWeight="800"
                    letterSpacing="0.06em"
                  >
                    Borrador
                  </Badge>
                )}
                {isIncomplete && (
                  <Badge
                    colorPalette="red"
                    variant="solid"
                    rounded="full"
                    px="2.5"
                    py="1"
                    fontSize="10px"
                    fontWeight="800"
                    letterSpacing="0.06em"
                  >
                    Incompleto
                  </Badge>
                )}
              </HStack>

              <Menu.Trigger asChild>
                <Box
                  as="button"
                  type="button"
                  display="grid"
                  placeItems="center"
                  boxSize="8"
                  rounded="full"
                  bg="blackAlpha.500"
                  color="white"
                  cursor="pointer"
                  aria-label="Opciones de actividad"
                  flexShrink={0}
                  _hover={{ bg: "blackAlpha.700" }}
                  _focusVisible={{ outline: "2px solid", outlineColor: "white", outlineOffset: "2px" }}
                >
                  <MdMoreHoriz />
                </Box>
              </Menu.Trigger>
            </HStack>
          </Box>

          {/* Content */}
          <Flex flex="1" direction="column" p={{ base: "5", md: "6" }} gap="3">
            <Box>
              <Text
                fontFamily="display"
                fontWeight="700"
                fontSize={{ base: "xl", md: "2xl" }}
                color="dashboard.fg.default"
                lineHeight="1.15"
              >
                {nombre}
              </Text>
              <Text fontSize="sm" color="dashboard.fg.muted" fontWeight="500" mt="1">
                {fecha}
              </Text>
            </Box>

            <Text
              fontSize="sm"
              color="dashboard.fg.muted"
              lineHeight="1.75"
              lineClamp={3}
              flex="1"
            >
              {desc}
            </Text>

            <HStack gap="2" wrap="wrap">
              {[horaInicio, horaFin].filter(Boolean).map((t) => (
                <Badge
                  key={t}
                  bg="dashboard.tag.bg"
                  color="dashboard.tag.fg"
                  borderWidth="1px"
                  borderColor="dashboard.tag.border"
                  rounded="full"
                  px="2.5"
                  py="0.5"
                  fontSize="xs"
                  fontWeight="700"
                >
                  {t}
                </Badge>
              ))}
            </HStack>

            <Box pt="1">
              <Link to={`/dashboard/club/actividades/${id}`}>
                <Button color="red" variant="solid" w={{ base: "100%", md: "auto" }}>
                  <MdEdit />
                  Editar actividad
                </Button>
              </Link>
            </Box>
          </Flex>

        </Flex>
      </Card.Root>

      <Portal>
        <Menu.Positioner>
          <Menu.Content bg="dashboard.bg.popover" color="dashboard.fg.default" borderColor="dashboard.border.default">
            <Menu.Item value={published ? "unpublish" : "publish"} onClick={doTogglePublish} {...menuItemProps}>
              {published ? "Despublicar" : "Publicar"}
            </Menu.Item>
            <Menu.Separator />
            <Menu.Item value="delete" onClick={doDelete} color="dashboard.feedback.error" {...menuItemProps}>
              Eliminar
            </Menu.Item>
          </Menu.Content>
        </Menu.Positioner>
      </Portal>
    </Menu.Root>
  );
}

export default MainAct;
